// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AcceptRefundInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/accept_refund/{id}
 *
 * Validates input for accepting a refund request.
 */
import { registerContract } from './validate'

export interface Payroll_AcceptRefundInput {
categoria_id: number
period_id?: number
}

registerContract('Payroll_AcceptRefundInput', {
  categoria_id: { type: 'number',  required: true },
  period_id:    { type: 'number',  required: false },
})
